import React from 'react'
import AdminWatchAds from '../../Components/AdminWatchAds'

const AdminWatchAdsTasks = () => {
  return (


      <AdminWatchAds/>
 
  )
}

export default AdminWatchAdsTasks